var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.53197 12.2065C10.14 11.931 10.6773 11.5766 11.1493 11.1549C8.46757 11.4905 5.77802 10.0838 4.61114 7.50909C3.44426 4.93436 4.15949 1.98465 6.17962 0.189313C5.55139 0.266203 4.93067 0.436675 4.32267 0.712223C1.12635 2.16082 -0.300892 5.91121 1.13687 9.08365C2.57464 12.2561 6.33564 13.6551 9.53197 12.2065Z",
    fill: "#27346A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.a5398c6d69329b9c24687ce0074cfa8d.svg";
export { ForwardRef as ReactComponent };